import styled from "styled-components";

export const Section = styled.section`
  margin-bottom: 2rem;
`
export const Header = styled.h2`
  color: ${({ theme }) => theme.palette.content.contrastText};
`
